<template>
  <div class="finished" v-loading="loading">
    <div class="tips">
      {{success ? '认证成功' : '认证失败'}}，请关闭该页面！
    </div>
  </div>
</template>

<script>
import { FaceAuthControllerSvr } from '@/service/FaceAuthControllerSvr.js';
export default {
  data() {
    return {
      loading: false,
      resultKey: '',
      recordsId: '',
      success: false,
      second: 3,
      timer: null,
    };
  },
  created() {
    this.FaceAuthControllerSvr = new FaceAuthControllerSvr();
    this.getUrl();
  },
  methods: {
    getUrl() {
      const url = window.decodeURIComponent(window.location.href);
      // 使用URL接口创建一个新的URL对象
      const urlObj = new URL(url);
      // 获取URL中的查询字符串部分
      const queryParams = urlObj.hash.substring(1); // 得到 "recordsId=90adb93d-4543-4195-b656-ec84071ca826?resultKey=4009e71e-9a5c-401a-b4bd-5729fc11ab69gongn"
      // 将第二个问号替换为&符号，使其成为一个合法的查询字符串
      const correctedQueryParams = queryParams
        .split('?')
        .slice(1)
        .join('&');
      // 使用URLSearchParams接口处理修正后的查询字符串
      const searchParams = new URLSearchParams(correctedQueryParams);
      // 获取recordsId和resultKey的值
      const recordsId = searchParams.get('recordsId');
      const resultKey = searchParams.get('resultKey');
      const token = searchParams.get('token');

      this.sendAuth(token, resultKey, recordsId);
    },
    sendAuth(token, resultKey, recordsId) {
      this.loading = true;
      this.FaceAuthControllerSvr.getResultByKey(token, resultKey, recordsId)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.success = true;
            localStorage.setItem('isAuthSuccess', 1);
            this.$message({
              type: 'success',
              message: '认证成功',
            });
          } else {
            this.success = false;
            localStorage.setItem('isAuthSuccess', 0);
            this.$message({
              type: 'error',
              message: '认证失败，请重试或在材料附件中上传身份证明',
            });
          }
        })
        .catch((err) => {
          this.success = false;
          this.loading = false;
          localStorage.setItem('isAuthSuccess', 0);
          this.$message({
            type: 'error',
            message: '认证失败，请重试或在材料附件中上传身份证明',
          });
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.finished {
  .tips {
    display: flex;
    justify-content: center;
    margin-top: 360px;
    font-size: 40px;
  }
}
</style>
